import React, { useContext, useEffect, useState } from "react";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import EndpointsEnum from "../../../models/EndpointsEnum";
import * as _ from "lodash-es";
import IGetFileUploadDTO from "../../../models/DTO/IGetFileUploadDTO";
import IDeleteFileUploadDTO from "../../../models/DTO/IDeleteFileUploadDTO";
import IOnGetFileUpload from "../../../models/DTO/IOnGetFileUpload";
import IPurchase_Order from "../../../models/IPurchase_Order";
import OwS3Uploader from "../../shared/OwS3Uploader/OwS3Uploader";
import FileUploadResourceTypeEnum from "../../../models/FileUploadResourceTypeEnum";
import AttachmentListItem from "../../order_entry/OrderEntryFileManager/AttachmentListItem/AttachmentListItem";
import IAttachment from "../../../models/IAttachment";
import { Socket } from "socket.io-client";

type Props = {
    socket: Socket;
    purchaseOrder: IPurchase_Order;
    isReadOnly: boolean;
};

export const PurchaseOrderFileManager: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [retrievingFile, setRetrievingFile] = useState<IAttachment | undefined>(undefined);

    useEffect(() => {
        props.socket.on(EndpointsEnum.FileUploadOnGetFileUpload, onGetFileUpload);

        return () => {
            props.socket.removeListener(EndpointsEnum.FileUploadOnGetFileUpload, onGetFileUpload);
        };
    });

    const getFileUpload = () => {};

    const onGetFileUpload = (data: IOnGetFileUpload) => {
        if (retrievingFile) {
            const blob = new Blob([data.Body], { type: data.ContentType });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            // const attachment = _.find(props.purchaseOrder.attachments, (attachment) => {
            //     return attachment.etag === data.ETag;
            // });
            const attachment = { name: retrievingFile.name };

            if (attachment) {
                const fileName = attachment.name;

                link.download = fileName;
                link.click();

                setRetrievingFile(undefined);
            } else {
                setRetrievingFile(undefined);

                // this.setState({
                //     showAlert: true,
                //     retrievingFile: false,
                // });
            }
        }
    };

    const downloadAttachment = (attachmentGuid: string) => {
        const payload: IGetFileUploadDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            attachmentGuid,
        };

        props.socket.emit(EndpointsEnum.FileUploadGetFileUpload, payload);

        const attachment = (props.purchaseOrder.Attachments || []).find((att) => {
            return att.guid === attachmentGuid;
        });

        setRetrievingFile(attachment);
    };

    const deleteAttachment = (attachmentGuid: string) => {
        const payload: IDeleteFileUploadDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            attachmentGuid,
        };

        props.socket.emit(EndpointsEnum.FileUploadDeleteFileUpload, payload);
    };

    const attachments = props.purchaseOrder ? props.purchaseOrder.Attachments : [];

    const attachmentItems = _.map(attachments, (attachment, index) => {
        return (
            <AttachmentListItem
                key={index}
                attachment={attachment}
                downloadAttachment={downloadAttachment}
                deleteAttachment={deleteAttachment}
                isReadOnly={props.isReadOnly}
            />
        );
    });

    return (
        <div className={"PurchaseOrderFileManager"}>
            <div className={"col-md-3 col-12"}>
                <OwS3Uploader
                    supplierModel={supplierModel}
                    socket={props.socket}
                    userModel={userModel}
                    isReadOnly={false}
                    resourceType={FileUploadResourceTypeEnum.purchaseOrderItem}
                    purchaseOrderGuid={props.purchaseOrder.guid}
                />
            </div>
            <hr className={"d-md-none"} />
            <div className={"d-none d-md-inline-flex col-md-auto"}>
                <div className="d-inline-block h-100" style={{ width: "1px", backgroundColor: "#CCC" }}></div>
            </div>
            <div className={"col-12 col-md-8"}>{attachmentItems}</div>
        </div>
    );
};
